import { IGoal } from "motw_core/Entity/IGoal";
import { logRepository } from "motw_core/Repositories/LogRepository";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { SetEventToDoneAsync } from "source/app/presentation/MainPanel/Calendar/DoneSwitch/SetEventToDoneAsync";
import { GetMatchingCalendarEvent } from "source/app/presentation/MainPanel/Goals/DailyGoals/DailyGoal/GetMatchingCalendarEvent";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import {
    OnErrorAddLogEntry,
    OnFinishAddLogEntry,
} from "source/app/services/Log/AddEntry";
import * as toastr from "toastr";

export async function HandlePostingDailyGoalAsync(goal: IGoal) {
    const matchingCalendarEvent = GetMatchingCalendarEvent(goal);

    if (matchingCalendarEvent) {
        toastr.info(
            `Found matching calendar event "${matchingCalendarEvent.name}"`,
            ``,
            { timeOut: 1000 }
        );

        const calendarEvent = new CalendarEvent(matchingCalendarEvent);

        await SetEventToDoneAsync(calendarEvent, goal);
    } else {
        await logRepository.AddOneTimeLogEntryAsync(
            goal.verb,
            goal.name,
            ClientDataProvider,
            OnErrorAddLogEntry,
            OnFinishAddLogEntry
        );
    }

    Data.Load.AllAsync();
}
